import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { HeroBanner } from '../components/CampaignBanner';
import {
  HeroSection,
  QuickSearchBar,
  LifestyleCategories,
  FeaturedProducts,
  StatsSection,
  FeaturesSection,
  TestimonialsSection,
  CTASection,
  SocialFeedSection
} from '../components/home';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [searchParams] = useSearchParams();

  // Track referral/affiliate codes from URL parameters on any landing page
  useEffect(() => {
    const refCode = searchParams.get('ref');
    const affCode = searchParams.get('aff');
    const campaignCode = searchParams.get('campaign');
    
    if (refCode) {
      localStorage.setItem('referral_code', refCode.toUpperCase());
      console.log('Referral code tracked from home:', refCode);
    }
    if (affCode) {
      localStorage.setItem('affiliate_code', affCode.toUpperCase());
      console.log('Affiliate code tracked from home:', affCode);
    }
    if (campaignCode) {
      localStorage.setItem('campaign_code', campaignCode.toUpperCase());
      console.log('Campaign code tracked from home:', campaignCode);
    }
  }, [searchParams]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await axios.post(`${API_URL}/api/seed`);
        const res = await axios.get(`${API_URL}/api/products`);
        setProducts(res.data);
      } catch (e) {
        console.error('Error fetching products:', e);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <QuickSearchBar />
      
      {/* Campaign Banner - Hero Style */}
      <section className="py-12 section-padding bg-[#f0f4f8]">
        <div className="max-w-7xl mx-auto">
          <HeroBanner className="animate-fade-in" />
        </div>
      </section>

      <LifestyleCategories />
      <FeaturedProducts products={products} />
      <StatsSection />
      <FeaturesSection />
      {/* TestimonialsSection removed - will be added when actual testimonials are available */}
      <SocialFeedSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
